import React from 'react';
import { Text } from '@amzn/atoz-web';
import { useTranslation } from 'react-i18next';
export var EstimatedPaidHours = function (_a) {
    var paidDuration = _a.paidDuration;
    var t = useTranslation().t;
    return (React.createElement(Text, { dataTestId: "estimated-paid-hours", fontSize: "T200" },
        t('shift_management_features_PayBreakdown_estimated_hours'),
        React.createElement(Text, { dataTestId: "estimated-paid-hours-duration", fontWeight: "medium", fontSize: "T200", display: "inline" }, paidDuration)));
};
